import { render, staticRenderFns } from "./DePager.vue?vue&type=template&id=60421990&"
import script from "./DePager.vue?vue&type=script&lang=js&"
export * from "./DePager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports